import Apptimize from '@apptimize/apptimize-web-sdk'

const getApptimizeStringArray = (
  variableName: string,
  defaultValue: string[]
): string[] => {
  const override = window?.apptimizeStringArray?.[variableName]
  if (Array.isArray(override)) {
    return override
  }
  return Apptimize.getStringArray(variableName, defaultValue)
}

export default getApptimizeStringArray
